export const restServices = {

	userInfo: 'user-info',
	sendInvite: 'send-invite',
	activationUser: 'activation-user',
};
